import React from 'react';
import ArmoryCardPrimAttch from './ArmoryCardPrimAttch';
import { useLoadout } from '../context/LoadoutContext';

export default function ArmoryItemCardLgPrim(props) {
  const loadoutCon = useLoadout();

  const handleClick = e => {
    // const clickedItem = e.target.dataset.id;
    const clickedItemCat = e.target.dataset.cat;
    const clickedItemType = e.target.dataset.type;
    const clickedLoadoutKey = e.target.dataset.lkey;

    loadoutCon.setWebGearSearch(clickedItemCat, clickedItemType);
    loadoutCon.setLoadoutItemKey(clickedLoadoutKey);
  };

  return (
    // <div className='armory_card_lg w-full overflow-hidden sm:my-1 sm:px-1 sm:w-1/2 md:my-1 md:px-1 md:w-1/2 lg:my-1 lg:px-1 lg:w-1/2 xl:my-1 xl:px-1 xl:w-1/2'>
    <div className='armory_card_lg w-full border border-gray-800'>
      {/* <div className='armory_card_lg w-full overflow-hidden sm:my-1 sm:px-1 sm:w-1/2 md:my-1 md:px-1 md:w-1/2 lg:my-1 lg:px-1 lg:w-1/2 xl:my-1 xl:px-1 xl:w-1/2'> */}
      <div className='armory_card_main '>
        <div className='armory_card_title bg-gray-800 uppercase text-gray-200 text-left flex justify-between items-center p-1'>
          <p className='font-bold tracking-wide'> {props.title}</p>
          <p className='sm:text-sm lg:text-base'> {props.name}</p>
        </div>

        <div className='bg-gray-900 border-b border-gray-800'>
          <img
            src={`${props.icon1}`}
            alt={`${props.title} icon`}
            title={props.name}
            className='h-32 mx-auto cursor-pointer hover:opacity-80 transition ease-in'
            data-cat={props.cat1}
            data-type={props.type1}
            data-lkey={props.loadoutName1}
            onClick={handleClick}
          />
        </div>
      </div>

      {/* <div className='armory_card_attachments flex justify-between mt-1'> */}
      <div className='armory_card_attachments grid grid-cols-4 border-gray-800 divide-x divide-gray-800'>
        <ArmoryCardPrimAttch
          title={'Sight'}
          name={loadoutCon.P_Sight.uName}
          URL1={loadoutCon.P_Sight.URL1}
          sku1={loadoutCon.P_Sight.SKU}
          cat1={'Sight'}
          type1={'Sight'}
          loadoutName1={'P_Sight'}
        />
        <ArmoryCardPrimAttch
          title={'Grip'}
          name={loadoutCon.P_Grip.uName}
          URL1={loadoutCon.P_Grip.URL1}
          sku1={loadoutCon.P_Grip.SKU}
          cat1={'Grip'}
          type1={'Grip'}
          loadoutName1={'P_Grip'}
        />
        <ArmoryCardPrimAttch
          title={'Barrel'}
          name={loadoutCon.P_Barrel.uName}
          URL1={loadoutCon.P_Barrel.URL1}
          sku1={loadoutCon.P_Barrel.SKU}
          cat1={'Barrel'}
          type1={'Barrel'}
          loadoutName1={'P_Barrel'}
        />
        <ArmoryCardPrimAttch
          title={'Tactical'}
          name={loadoutCon.P_Tactical.uName}
          URL1={loadoutCon.P_Tactical.URL1}
          sku1={loadoutCon.P_Tactical.SKU}
          cat1={'Tactical'}
          type1={'Tactical'}
          loadoutName1={'P_Tactical'}
        />
      </div>
    </div>
  );
}
